export default {
    BOLETO: 'Boleto',
    CARTAO_CREDITO: 'Cartão de Crédito',
    A_DEFINIR: 'A Definir',
    CREDIT_CARD: 'Cartão de Crédito',
    DEBIT_CARD: 'Cartão de Débito',
    UNDEFINED: 'Perguntar ao cliente',
    TRANSFER: 'Transferência bancária',
    DEPOSIT: 'Depósito bancário',
    PIX: 'PIX'
}
